import React from "react";
import { connect } from "react-redux";
import { AppDispatch, RootState } from "store/store";
import { setSelectedIndex } from "../../store/slices/DocsSlice";
import PromineoTabPanel from "components/common/controls/PromineoTabPanel";
import HowItWorks from "./HowItWorks";
import ViewExamples from "./ViewExamples";
import DevelopersSection from "./DevelopersSection";
import { ScrollView } from "devextreme-react";
import "./styles/Documentation.css";

interface DocItem {
  title: string;
  component: React.ComponentType<any>;
}

interface Props {
  dispatch: AppDispatch;
  selectedIndex: number;
}

const docItems: DocItem[] = [
  {
    title: "How it works",
    component: HowItWorks,
  },
  {
    title: "View Examples",
    component: ViewExamples,
  },
  {
    title: "Developers section",
    component: DevelopersSection,
  },
];

export function Docs(props: Props) {
  const { selectedIndex, dispatch } = props;

  const ContentComponent = () => {
    const Component: React.ComponentType<any> =
      docItems[selectedIndex].component;

    return (
      <div className="h-full bg-white">
        <ScrollView direction={"both"} showScrollbar="always" useNative>
          <div className="py-4 pb-0">
            <Component />
          </div>
        </ScrollView>
      </div>
    );
  };

  const onSelectionChanged = (args: any) => {
    if (args.name === "selectedIndex") {
      dispatch(setSelectedIndex(args.value));
    }
  };

  return (
    <div className="documentation-tabPanel">
      <PromineoTabPanel
        dataSource={docItems}
        itemComponent={ContentComponent}
        selectedIndex={selectedIndex}
        onOptionChanged={onSelectionChanged}
        animationEnabled
      />
    </div>
  );
}

const mapStateToProps = (state: RootState, props: any) => {
  return {
    selectedIndex: state.docsData.selectedIndex,
    ...props,
  };
};

export default connect(mapStateToProps)(Docs);
